var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPost24Line = function SvgIconPost24Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.463 5.965c0-.47.38-.85.85-.85h13.38c.469 0 .85.38.85.85v8.95c0 .8-.651 1.45-1.45 1.45H5.913c-.8 0-1.45-.65-1.45-1.45v-8.95Zm1.7.85v7.85h11.68v-7.85H6.163Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.387 6.815H3.617v-1.7h16.77v1.7ZM6.717 18.616l3.205-3.6 1.12.997-3.204 3.6-1.12-.997ZM16.166 19.613l-3.205-3.6 1.12-.997 3.206 3.6-1.12.997ZM16.277 10.08h-8.55v-1.5h8.55v1.5ZM12.002 12.75H7.727v-1.5h4.275v1.5Z",
    fill: "current"
  })));
};
export default SvgIconPost24Line;